import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import PolicyIcon from "@mui/icons-material/Policy";
import DeleteIcon from "@mui/icons-material/Delete";

import { useToggle } from "hooks/useToggle";
import { useForm } from "hooks/useForm";
import RegularButton from "components/CustomButtons/Button";
import CardTable from "components/CardTable/CardTable";
import { ModalV2 } from "components/Modal/ModalV2";
import { validateObject } from "helpers/validateObject";

import {
  getPolicyAccountsAction,
  addMovementToPolicyAction,
  deleteMovementToPolicyAction,
} from "redux/actions/policyManagment/policyManagmentActions";

import { LoadPolicyInputs } from "./LoadPolicyInputs";
import { PolicyMovForm } from "./PolicyMovForm";
import { columns } from "./columns";
import { initialValues } from "./initialValues";

export const PolicyForm = ({ tableKey }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useToggle();
  const { policy, accounts, station } = useSelector(
    ({ policyManagment }) => policyManagment
  );
  const { isLoadingComp } = useSelector(({ search }) => search);
  const {
    values,
    onChange,
    setValues,
    validate,
    errors,
    reset,
    onChangeNumberV2,
  } = useForm(initialValues.values, initialValues.required);
  const [byPayment, setByPayment] = useToggle();
  const [openDelete, setOpenDelete] = useToggle();
  const { account, charge, payment, concept } = values;

  const handleReset = () => {
    reset();
    setOpen();
  };

  const getAccounts = () => {
    dispatch(getPolicyAccountsAction(station.id, handleReset));
  };

  const handleMovementSubmit = () => {
    let isByPayment = [];
    if (byPayment) {
      isByPayment = ["charge"];
    } else {
      isByPayment = ["payment"];
    }
    validate(isByPayment, () => {
      const form = {
        idPolicy: policy.id,
        idAccountingAccount: account.id,
        charge: !byPayment ? Number(charge) : null,
        payment: byPayment ? Number(payment) : null,
        concept,
        number: account.number,
        name: account.name,
      };
      dispatch(addMovementToPolicyAction(form, setOpen));
    });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5" color="info">
          Tipo de Poliza {values.type}
        </Typography>
      </Grid>
      <LoadPolicyInputs />
      <CardTable
        data={policy?.details || []}
        columns={columns}
        hasHeader
        blockBtn
        title="Poliza movimientos contables"
        icon={<PolicyIcon />}
        hasControl
        tableKey={tableKey}
        isLoading={isLoadingComp?.createPolicy || isLoadingComp?.search}
        controls={
          <>
            {policy?.details?.length > 0 &&
              validateObject(policy) &&
              policy.status === "CREATE" && (
                <RegularButton
                  round
                  justIcon
                  color="danger"
                  onClick={setOpenDelete}
                  loading={isLoadingComp?.deleteMovementToPolicy}
                >
                  <DeleteIcon style={{ margin: 0 }} />
                </RegularButton>
              )}
            {validateObject(policy) && policy.status === "CREATE" && (
              <RegularButton
                round
                justIcon
                color="twitter"
                onClick={getAccounts}
                tooltip="Agregar Movimiento"
                loading={isLoadingComp?.getPolicyAccounts}
              >
                <Add style={{ margin: 0 }} />
              </RegularButton>
            )}
          </>
        }
      />
      <ModalV2
        open={open}
        onClose={setOpen}
        justConfirm
        title="Crear movimiento"
        onSubmit={handleMovementSubmit}
        loading={isLoadingComp?.addMovementToPolicy}
      >
        <PolicyMovForm
          values={values}
          onChange={onChange}
          onChangeNumber={onChangeNumberV2}
          setValues={setValues}
          errors={errors}
          accounts={accounts}
          byPayment={byPayment}
          setByPayment={setByPayment}
        />
      </ModalV2>
      <ModalV2
        open={openDelete}
        onClose={setOpenDelete}
        title={`¿Eliminar todos los movimientos?`}
        justConfirm
        onSubmit={() =>
          dispatch(deleteMovementToPolicyAction(null, policy.id, setOpenDelete))
        }
        loading={isLoadingComp?.deleteMovementToPolicy}
      />
    </Grid>
  );
};
